import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import incentive2Png from "@assets/images/variant-jaangal/post/incentive2.png";
import { gap } from "@ui/styles/utils";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { row } from "@ui/components/layout";

interface EmptyFeedIncentiveProps extends React.HTMLAttributes<HTMLDivElement> {
	onCreatePost?: () => void;
}
export const EmptyFeedIncentive: React.FC<EmptyFeedIncentiveProps> = ({ onCreatePost, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<Content>
				<PrimaryMedium>{I18n.t("feed.incentive.info")}</PrimaryMedium>
				<CreateButton onClick={() => onCreatePost?.()}>{I18n.t("feed.incentive.button")}</CreateButton>
			</Content>
			<img src={incentive2Png} />
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	max-height: 206px;
	${row(5)};
	> img {
		max-height: 206px;
	}
	@media (max-width: 1440px) {
		> img {
			display: none;
		}
	}
`;

const Content = styled.div`
	${gap(15)};
	padding: 45px 0px 45px 33px;

	@media (max-width: 1140px) {
		padding: 45px 16px 45px 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
`;

const CreateButton = styled(PrimaryButton)`
	padding: 12px 30px;
`;
